import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./WeightInput.module.css";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const WeightInput: React.FC<Props> = ({ value, onChange }) => {
  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "") {
      onChange(value); // allow the user to clear the input, when we see a "" value we will calc its weight as 0
      return;
    }

    const float = parseFloat(value);
    if (isNaN(float)) {
      return;
    }

    if (float < 0 || float > 100) {
      return;
    }

    // only allow 1 decimal point
    const numberParts = value.split(".");
    if (numberParts.length > 2) {
      return;
    }

    // only allow 2 decimal places max
    if (numberParts.length === 2 && numberParts[1].length > 2) {
      return;
    }

    const result = value.trim();

    const numberRegex = /^[0-9.]*$/;
    if (!numberRegex.test(result)) {
      return;
    }

    onChange(result);
  };

  const onBlurInput = () => {
    if (value === "") {
      onChange("0.00");
    }
  };

  return (
    <div className={styles.container}>
      <input
        className={styles.input}
        value={value}
        placeholder={"0.00"}
        type={"text"}
        onChange={onChangeInput}
        onBlur={onBlurInput}
      />

      <Text className={styles.percentChar} variant="body" color="textSubtle">
        %
      </Text>
    </div>
  );
};

export default WeightInput;
